module.exports = __webpack_public_path__ + "img/shandui.12e5631b.png";